import { Record as record } from 'immutable';
import { construct, fields } from '../../../../src/helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';

const schema = {
    id: [ fields.string ],
    requiresStation: [ fields.bool ],
    requiresOther: [ fields.bool ]
};

export default class CompensationPurchaseLocation extends record(getDefaults(schema)) {
    static fromJSON (json = {}) {
        return construct(CompensationPurchaseLocation, json, getResolvers(schema));
    }
}
